/* eslint-disable indent */
export function footerDropDown() {
  $(".footer-nav-title  .footer-drop-btn").on("click", function (e) {
    const $title = $(this).parent();
    let thisContentBlock = $title.parent().find(".footer-nav-sub-element");
    if (thisContentBlock.hasClass("active")) {
      thisContentBlock.slideUp();
      thisContentBlock.removeClass("active");
      $(this).removeClass("opened");
    } else {
      $(this).addClass("opened");
      thisContentBlock.slideDown();
      thisContentBlock.addClass("active");
    }
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/footerDropDown.js